import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { LoadingController, Loading } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { TransactionEditPage,  TRANSACTION_UPDATED_EVENT} from '../transaction-form/transaction-form-edit';
import { Events } from 'ionic-angular';
/**
 * Generated class for the ReportDetailedPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
    selector: 'page-report-detailed',
    templateUrl: 'report-detailed.html',
})
export class ReportDetailedPage {
    report = {
        start_date: "",
        end_date: ""
    }

    data = {}

    visible_groups = []

    current_sliding_item: any;

    show_date_range = false

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public server: ServerProvider, public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,public events: Events
    ) {

        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0, 23, 59, 59);

        this.report.start_date = firstDay.toISOString()
        this.report.end_date = lastDay.toISOString()

        events.subscribe(TRANSACTION_UPDATED_EVENT, (transaction)=>{
            console.log('Updated transaction is ', transaction)
            if(this.current_sliding_item != null){
                this.current_sliding_item.close()
            }
        })

        this.fetchReport()
    }

    toggleShowDateRange(){
        this.show_date_range = ! this.show_date_range
    }

    fetchReport() {
        let start_date = new Date(this.report.start_date);
        start_date.setHours(23);
        start_date.setMinutes(59);

        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present();

        this.server.getDetailedMonthlyReport(start_date, new Date(this.report.end_date)).subscribe(
            data => {
                this.data = data.json()
                loader.dismiss()
            },
            error => {
                loader.dismiss()
            }
        );
    }

    editTransaction(idx, t, slidingItem) {
        this.current_sliding_item = slidingItem

        let modal = this.modalCtrl.create(TransactionEditPage, {"user_id":t.user_id, "account_id":t.account_id, "transaction": t});
        modal.present();
    }

    toggleGroup(category) {
        if (this.isGroupShown(category)) {
            this.visible_groups.splice(this.visible_groups.indexOf(category), 1)
        }
        else {
            this.visible_groups.push(category)
        }
    }

    isGroupShown(category) {
        return this.visible_groups.indexOf(category) > -1;
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad ReportPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/report-detailed/report-detailed.ts